import { useTranslation } from "@privacy/translations";
import { useQuery } from "@tanstack/react-query";
import { DynamicGrid } from "../dynamicGrid";
import { DynamicHistory } from "../dynamicHistory";
import { logUnhandled } from "../api/logError";
import { PersonIcon3, TenantIcon3 } from "../shared/icons";
import { Drawer } from "../shared/Drawer";
import { sharedProcessingByIdQueryOptions, sharedProcessingHistoryQueryOptions } from "../api/sharedProcessings";
import { SharedProcessingDrawerHeader } from "./SharedProcessingDrawerHeader";

export const SharedProcessingHistoryDrawer = () => {
  const sharedProcessingId = DynamicGrid.useSelectedRowId();
  const { t } = useTranslation();
  const historyQuery = useQuery(sharedProcessingHistoryQueryOptions(sharedProcessingId));
  const sharedProcessingQuery = useQuery(sharedProcessingByIdQueryOptions(sharedProcessingId));

  return (
    <DynamicGrid.Drawer>
      {(() => {
        if (!sharedProcessingQuery.data) return <Drawer.Loading />;

        return (
          <>
            <SharedProcessingDrawerHeader
              sharedProcessing={sharedProcessingQuery.data}
              activeTab="history"
              statusIndicator={"hidden"}
            />

            {!historyQuery.data ? (
              <Drawer.Loading />
            ) : (
              <DynamicHistory.Entries
                historyEntries={historyQuery.data.history}
                renderCustomEntry={entry => {
                  switch (entry.customType) {
                    case "registrationName":
                      return (
                        <DynamicHistory.BeforeAndAfterEntry
                          {...entry}
                          header={t("Registration.Name")}
                          before={<DynamicHistory.SnapshotValueText>{entry.oldValue}</DynamicHistory.SnapshotValueText>}
                          after={<DynamicHistory.SnapshotValueText>{entry.newValue}</DynamicHistory.SnapshotValueText>}
                        />
                      );
                    case "registrationResponsible":
                      return (
                        <DynamicHistory.BeforeAndAfterEntry
                          {...entry}
                          header={t("RegistrationGrid.ResponsibleHeader")}
                          before={
                            <DynamicHistory.SnapshotValueText Icon={PersonIcon3}>
                              {entry.oldValue.firstName} {entry.oldValue.lastName}
                            </DynamicHistory.SnapshotValueText>
                          }
                          after={
                            <DynamicHistory.SnapshotValueText Icon={PersonIcon3}>
                              {entry.newValue.firstName} {entry.newValue.lastName}
                            </DynamicHistory.SnapshotValueText>
                          }
                        />
                      );
                    case "sharedRegistrationAddedToOrganisation":
                      return (
                        <DynamicHistory.BeforeAndAfterEntry
                          {...entry}
                          header={t("SharedProcessing.History.SharedWithOrganisation")}
                          before={<DynamicHistory.EmptyValue />}
                          after={
                            entry.newValue ? (
                              <DynamicHistory.SnapshotValueText Icon={TenantIcon3}>
                                {entry.newValue.name}
                              </DynamicHistory.SnapshotValueText>
                            ) : (
                              <DynamicHistory.EmptyValue />
                            )
                          }
                        />
                      );
                    default:
                      return logUnhandled(entry, "custom entry");
                  }
                }}
              />
            )}
          </>
        );
      })()}
    </DynamicGrid.Drawer>
  );
};
